// Error boundaries must be Client Components
'use client';
import { Button, Container, Text } from '@chakra-ui/react';
import { useEffect } from 'react';

import { useI18n } from '@/__generated__/i18n.next';
import { Alert } from '@/components/__generated__/chakra-ui/alert';
import { createDateTimeFormatter } from '@/infrastructures/atDecorators/memoize';
import { useSession } from '@/infrastructures/betterAuth/authClient';
import { reportClientError } from '@/infrastructures/reportClientError';

import { DefaultFooterOnClient } from '../../components/organisms/DefaultFooterOnClient';

const Error: React.FC<{ error: Error & { digest?: string }; reset: () => void }> = ({ error }) => {
  const t = useI18n();
  const { data: session, isPending } = useSession();

  const dateFormatter = createDateTimeFormatter(undefined, {
    dateStyle: 'medium',
    timeStyle: 'medium',
  });
  useEffect(() => {
    console.error(error);
    reportClientError(error, isPending ? undefined : session?.user.id);
  }, [error, session?.user.id, isPending]);

  return (
    <>
      <Container py={16}>
        <Alert rounded="md" status="error" title={t.pages.error.unexpectedError()}>
          {t.pages.error.unexpectedErrorMessage()}
          <Text as={'span'} color="fg.subtle" fontSize="sm">
            ({dateFormatter.format()})
          </Text>
          {process.env.NEXT_PUBLIC_WB_ENV !== 'production' && (
            <Text as={'span'} color="fg.subtle" fontSize="sm">
              {error.digest}
            </Text>
          )}
        </Alert>
        <Button
          colorPalette="blue"
          mt={4}
          onClick={() => {
            globalThis.location.reload();
          }}
        >
          {t.core.reload()}
        </Button>
      </Container>

      <DefaultFooterOnClient />
    </>
  );
};

export default Error;
